export default class {
  constructor () {
    this.appHeight = this.appHeight.bind(this)
    this.appHeight()
    this.bindEvents()
  }

  bindEvents () {
    window.addEventListener('resize', this.appHeight)
    window.addEventListener('orientationchange', this.appHeight)
    document.addEventListener('turbo:load', this.appHeight)
    document.addEventListener('turbo:render', this.appHeight)
    document.addEventListener('tab-change', this.appHeight)
    document.addEventListener('collapse:toggle', this.appHeight)
    window.visualViewport?.addEventListener('resize', this.appHeight)
  }

  appHeight () {
    const height = window.visualViewport?.height || window.innerHeight
    document.documentElement.style.setProperty('--app-height', `${height}px`)
  }
}
